import { render, staticRenderFns } from "./addExamineTwo.vue?vue&type=template&id=b2b9f0d8&scoped=true&"
import script from "./addExamineTwo.vue?vue&type=script&lang=js&"
export * from "./addExamineTwo.vue?vue&type=script&lang=js&"
import style0 from "./addExamineTwo.vue?vue&type=style&index=0&id=b2b9f0d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b9f0d8",
  null
  
)

export default component.exports